export default __webpack_public_path__ + "static/media/30.9a6ef1f9.png";